import { gql, useMutation } from '@apollo/client'

import type { AddCustomerPickupAddress, CreateCustomerDeliveryAddress, CustomerAddress, UpdateCustomerDeliveryAddress } from '@@types'

export type CustomerAddressInput = CreateCustomerDeliveryAddress | UpdateCustomerDeliveryAddress | AddCustomerPickupAddress

export type SaveAddressVariables = {
  addressInfo: CustomerAddressInput
}

export type SaveAddressMutation = {
  saveAddress?: CustomerAddress | null
}

export const GQL_MUTATION_SAVE_ADDRESS = gql`
  mutation SaveAddress($addressInfo: CustomerAddressInput!) {
    saveAddress(addressInfo: $addressInfo) {
      id
      label
      shop_id
      shop {
        id
        name
        address
      }
      address
      address_appartments
      address_intercom
      address_porch
      address_floor
      door_delivery
      no_door_call
      customerGeoPoint {
        latitude
        longitude
      }
      other_recipient
      recipient_phone
      recipient_name
      recipient_last_name
      comment
    }
  }
`

/**
 * Хук для сохранения/обновления адреса пользователя
 */
export const useMutateSaveAddress = () =>
  useMutation<SaveAddressMutation, SaveAddressVariables>(GQL_MUTATION_SAVE_ADDRESS)
